import React from 'react';
import { CTAButton } from './ui/CTAButton';
const painPoints = ['Mirás videos de YouTube sobre aires y nunca das el primer paso real', 'Cada mes te prometés que vas a arrancar por tu cuenta y no pasa nada', 'Tenés manos y ganas pero no tenés un sistema ni nadie que te guíe', 'Ves cómo otros técnicos se llenan de trabajo en temporada y vos esperás', 'Dejás el cuerpo en un trabajo que no te valora y el sueldo no cambia'];
export function PainPointsSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-202">
      <div className="max-w-4xl mx-auto" data-id="element-203">
        <h2 className="text-3xl md:text-4xl font-black text-center text-brand-dark mb-12" data-id="element-204">
          Esto te va a sonar familiar:
        </h2>

        <div className="space-y-6 mb-12 bg-slate-50 p-8 rounded-2xl border border-slate-200" data-id="element-205">
          {painPoints.map((point, index) => <div key={index} className="flex items-start gap-4" data-id="element-206">
              <span className="text-2xl flex-shrink-0 mt-0.5" data-id="element-207">😤</span>
              <p className="text-lg md:text-xl font-medium text-gray-800" data-id="element-208">
                {point}
              </p>
            </div>)}
        </div>

        <div className="bg-brand-ice p-8 md:p-12 rounded-3xl border border-brand-secondary mb-12 text-center shadow-sm" data-id="element-209">
          <h3 className="text-2xl md:text-4xl font-black text-brand-dark mb-4" data-id="element-210">
            El problema no sos vos.
          </h3>
          <h3 className="text-2xl md:text-4xl font-black text-brand-primary" data-id="element-211">
            El problema es que nadie te dio el método correcto.
          </h3>
        </div>

        <div className="text-center" data-id="element-212">
          <div className="max-w-xl mx-auto" data-id="element-213">
            <CTAButton text="→ QUIERO EL MÉTODO Y EMPEZAR HOY" data-id="element-214" />
          </div>
        </div>
      </div>
    </section>;
}